module.exports = __webpack_public_path__ + "static/Bokeh_panel-cc18cb33cd31a751c8bb3cc396354645.png";